<template>
<v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title class="grey lighten-4">
                    <v-tooltip top>
                         <v-btn
                            slot="activator"
                            dark
                            @click.stop="helpdialog = true"
                            icon class="mx-0">
                        <v-icon color="red">help</v-icon>
                        </v-btn>
                        <span>Cajas/App</span>
                    </v-tooltip>
                    <h3 class="headline mb-0">Administración de Cajas</h3>

                    <v-spacer></v-spacer>
                        <v-text-field
                            @change="onChange"
                            slot="input"
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click="addCaja">Asignar Caja</v-btn>
                </v-card-title>
                <div>

                  <v-data-table
                    :headers="headers"
                    :items="cajas"
                    :pagination.sync="pagination"
                    :total-items="total"
                    :rows-per-page-items="rowsPerPageItems"
                    :loading="loading"
                    row
                    wrap
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.user_name.toUpperCase() }}</td>
                      <!-- <td>{{ props.item.user_email }}</td> -->
                      <td>{{ props.item.created_at }}</td>
                      <td>{{ props.item.created_at !== props.item.updated_at ? props.item.updated_at : '' }}</td>
                      <td>{{ props.item.status }}</td>
                      <td>{{ props.item.name_cash }}</td>
                      <td class="justify-center layout px-0">
                        <v-tooltip top>
                            <v-btn
                                :disabled="props.item.status === 'ABIERTA'"
                                slot="activator"
                                icon class="mx-0"
                                @click="openPdfReport(props.item,'resumen')"
                            >
                                <v-icon color="blue">
                                    picture_as_pdf
                                </v-icon>
                            </v-btn>
                            <span>Resumen</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <v-btn
                                :disabled="props.item.status === 'ABIERTA'"
                                slot="activator"
                                icon class="mx-0"
                                @click="openPdfReport(props.item,'detalle')"
                            >
                                <v-icon color="green">
                                    picture_as_pdf
                                </v-icon>
                            </v-btn>
                            <span>Detalle</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <v-btn
                                v-if="props.item.status === 'ABIERTA'"
                                slot="activator"
                                icon class="mx-0"
                                @click="cerrarCaja(props.item,'CERRADA')">
                                <v-icon color="red">
                                    phonelink_off
                                </v-icon>
                            </v-btn>
                            <v-btn
                                v-if="props.item.status === 'CERRADA' && props.item.updated_at !== null && new Date(props.item.updated_at).toISOString().slice(0,10) === new Date().toISOString().slice(0,10)"
                                slot="activator"
                                icon class="mx-0"
                                @click="cerrarCaja(props.item,'ABIERTA')">
                                <v-icon color="green">
                                    phonelink
                                </v-icon>
                            </v-btn>
                            <span>{{ props.item.status === 'ABIERTA' ? 'Cerrar Caja' : 'Reabrir Caja' }}</span>
                        </v-tooltip>
                      </td>

                    </template>
                  </v-data-table>
                </div>

            </v-card>
        </v-flex>


  <!-- Inicio de dialogo -->
    <v-dialog
          v-model="helpdialog"
          max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Cajas</v-card-title>

            <v-card-text>
              Mantenimiento de las cajas.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="helpdialog = false"
              >
                Salir
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

    <!-- dialog para form roles -->
    <v-dialog v-model="dialog" width="600">
      <FormCajas :loading="loading" :tipo="tipo" :datos="getCajas" v-on:closeDialogCaja="closeDialogCaja($event)" v-on:responseLoading="loading = $event" />
    </v-dialog>
    <!-- fin dialog form roles -->


    <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
    >
        <v-card
            color="primary"
            dark
        >
            <v-card-text>
            Porfavor Espere...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    </v-layout>
</template>

<script>
import axios from 'axios'
import FormCajas from '~/components/form/FormCajas.vue'

  export default {
    name: "admin-cajas-view",

    components: {
        FormCajas
    },

    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'Asignar caja a usuario' : 'Editar caja a usuario'
        },
        getCajas () {
            return this.editedItem
        },
    },

    data: () => ({
      dialog: false,
      helpdialog: false,
      loading: false,
      total: 0,
      tipo: '',
      search: '',
      pagination: {},
      dialogPermissionRole: false,
      headers: [
        { text: 'Nombre', align: 'left', sortable: false, value: 'user_name' },
        { text: 'Inicio', align: 'left', sortable: false, value: '' },
        { text: 'Fin', align: 'left', sortable: false, value: '' },
        { text: 'Status', align: 'left', sortable: false, value: 'status' },
        { text: 'Caja', align: 'left', sortable: false, value: 'name_cash' },
        { text: 'Acciones', align: 'center', value: '', sortable: false }
      ],
      rowsPerPageItems: [10, 20, 50, 100],
      cajas: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        description: ''
      },
      defaultItem: {
        name: '',
        description: ''
      }
    }),

    watch: {
        dialog (val) {
            val || this.close()
        },
        pagination() {
            this.getCajasActivasByPagination();
        }
    },

    methods: {

        editItem (item) {
            this.tipo = "editar"
            this.editedIndex = this.roles.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        addCaja () {
            this.tipo = "crear"
            this.dialog = true
        },

        async openPdfReport(item,tipo) {
            this.loading = true
            let downloadStatus = false
            await axios.post(`/api/administration/cajas/search-report`,{ item: item, tipo: tipo })
            .then(() => downloadStatus = true)
            .catch(e => {
                if (e.response.data.errors) {
                    if (e.response.data.errors.denegado) {
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: e.response.data.errors.denegado[0]
                        })
                    }
                }else {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: e.response.data.error
                    })
                }
            })

            if(downloadStatus){
                await axios({
                    url: `/api/administration/cajas/download-report/${item.id}/${tipo}`,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                .then(response => {
                    const blob = new Blob([response.data], {type: response.data.type});
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    const contentDisposition = response.headers['content-disposition'];
                    let fileName = 'unknown';
                    if (contentDisposition) {
                        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                        if (fileNameMatch.length === 2)
                            fileName = fileNameMatch[1];
                    }
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                })
            }
            
            this.loading = false
        },

        async cerrarCaja (item, status) {
            const index = this.cajas.indexOf(item)
            this.loading = true
            await axios.post(`/api/administration/cajas/${item.id}`,{ status: status }).then(res => {
                this.cajas = res.data.data;
                this.total = res.data.total;
            })
            .catch(e => {
                console.log(e.response)
                if (e.response.data.errors) {
                    if (e.response.data.errors.denegado) {
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: e.response.data.errors.denegado[0]
                        })
                    }
                }else {
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: e.response.data.error
                    })
                }
            })
            .finally(() => this.loading = false);
        },

        close () {
            this.dialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            }, 300)
        },

        async getCajasActivasByPagination() {
                this.loading = true;
                if (this.search) {
                    await axios.get(`/api/administration/cajas/cajas-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.cajas = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
                if (this.pagination.sortBy && !this.search) {
                    const direction = this.pagination.descending ? 'desc' : 'asc';
                    await axios.get(`/api/administration/cajas/cajas-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.cajas = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
                if(!this.search && !this.pagination.sortBy) {
                    await axios.get(`/api/administration/cajas?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                        .then(res => {
                            this.cajas = res.data.data;
                            this.total = res.data.total;
                        })
                        .finally(() => this.loading = false);
                }
            },

            onChange () {
                this.getCajasActivasByPagination();
            },

            closeDialogCaja (response) {
                if (response != null) {
                    var item = this.cajas.find(cajas => cajas.id === response.id)
                    if (this.tipo == 'crear') {
                        this.cajas.push(response)
                    }else {
                        Object.assign(item, response)
                    }
                    this.getCajasActivasByPagination();
                }
                this.dialog = false
                setTimeout(function(){
                    this.editItem = {}
                    this.tipo = ''
                }, 3000)

            }

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/adminCajas.vue